module.exports = __webpack_public_path__ + "static/media/usa.e499f1fb.png";